module.exports = __webpack_public_path__ + "static/media/533216_644930678864492_1698518237_n.82c83a57.jpg";